import {
  ADD_ASSIGNMENTS,
  CHANGE_ASSIGNEE_ID,
  CHANGE_ASSIGNER_ID,
  CHANGE_ASSIGNMENT_MODAL_OPEN,
  CHANGE_ITEMS_LIST,
  CHANGE_PARENTS_MAP,
  CHANGE_ROOT_NODE,
  REMOVE_ASSIGNMENT,
  RESET_ASSIGNMENTS,
  SET_ASSIGNMENTS,
} from "features/budget/wizard/state/wizard-assignment.actions";
import { getAllNodesCount } from "common/utils/tree/get-all-nodes-count";

const INITIAL_STATE = {
  assignmentModalOpen: false,
  assigneeId: null,
  assignerId: null,
  parentsMap: null,
  rootNode: null,
  assignments: null,
  itemsList: [],
  total: 0,
};

// eslint-disable-next-line default-param-last
const wizardAssignmentReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case CHANGE_ASSIGNMENT_MODAL_OPEN: {
      return {
        ...state,
        assignmentModalOpen: payload.open,
      };
    }
    case CHANGE_ASSIGNEE_ID: {
      return {
        ...state,
        assigneeId: payload.id,
      };
    }
    case CHANGE_ASSIGNER_ID: {
      return {
        ...state,
        assignerId: payload.id,
      };
    }
    case CHANGE_PARENTS_MAP: {
      return {
        ...state,
        parentsMap: new Map(payload.parentsMap),
      };
    }
    case CHANGE_ROOT_NODE: {
      const total = getAllNodesCount(payload.node);
      return {
        ...state,
        rootNode: { ...payload.node },
        total,
      };
    }
    case ADD_ASSIGNMENTS: {
      return {
        ...state,
        assignments: {
          ...state.assignments,
          ...payload.assignments,
        },
      };
    }
    case SET_ASSIGNMENTS: {
      return {
        ...state,
        assignments: payload.assignments,
      };
    }
    case CHANGE_ITEMS_LIST: {
      return {
        ...state,
        itemsList: [...payload.list],
      };
    }
    case REMOVE_ASSIGNMENT: {
      const newAssignments = { ...state.assignments };
      delete newAssignments[payload.id];

      return {
        ...state,
        assignments: { ...newAssignments },
      };
    }
    case RESET_ASSIGNMENTS: {
      return { ...INITIAL_STATE };
    }
    default:
      return state;
  }
};

export default wizardAssignmentReducer;
